// CSS Imports
import 'primeicons/primeicons.css';
import './assets/main.css';

// Vue Imports
import { createApp } from 'vue';
import { createPinia } from 'pinia';

// Contact Form reCaptcha
import { VueReCaptcha } from 'vue-recaptcha-v3';

import App from './App.vue';
import router from './router';

// PrimeVue Components
import PrimeVue  from 'primevue/config';
import Aura from '@primevue/themes/aura';
import Button from 'primevue/button';
import DatePicker from 'primevue/datepicker';
import ProgressSpinner from 'primevue/progressspinner';
import InputNumber from "primevue/inputnumber";
import InputText from 'primevue/inputtext';
import InputGroup from 'primevue/inputgroup';
import ScrollPanel from 'primevue/scrollpanel';
import Carousel from 'primevue/carousel';
import Dialog from 'primevue/dialog';
import RadioButton from 'primevue/radiobutton';
import Checkbox from 'primevue/checkbox';
import Tooltip from 'primevue/tooltip';
import Paginator from 'primevue/paginator';
import Select from 'primevue/select';
import ToggleSwitch from 'primevue/toggleswitch';
import Popover from 'primevue/popover';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import Rating from 'primevue/rating';
import Textarea from 'primevue/textarea';

// App Components
const app = createApp(App);

app.config.errorHandler = (err) => {
    console.log('There has been an error: ', err);
}

app.use(createPinia());
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Aura
    }
});
app.use(VueReCaptcha, { siteKey:'6LdGM4kpAAAAAFetig1T1xGsX1fcYlN5dPDhB0aa',loaderOptions: {autoHideBadge:true} });
app.use(ToastService);

app.component('Button',Button);
app.component('DatePicker',DatePicker);
app.component('ProgressSpinner',ProgressSpinner);
app.component('InputNumber',InputNumber);
app.component('InputText',InputText);
app.component('InputGroup',InputGroup);
app.component('ScrollPanel',ScrollPanel);
app.component('Carousel',Carousel);
app.component('Dialog',Dialog);
app.component('RadioButton', RadioButton);
app.component('Checkbox', Checkbox);
app.component('Paginator',Paginator);
app.component('Select',Select);
app.component('ToggleSwitch',ToggleSwitch);
app.component('Popover',Popover);
app.component('Tabs', Tabs);
app.component('TabList', TabList);
app.component('Tab', Tab);
app.component('TabPanels', TabPanels);
app.component('TabPanel', TabPanel);
app.component('Toast', Toast);
app.component('Rating', Rating);
app.component('Textarea',Textarea);

app.directive('tooltip', Tooltip);

app.mount('#app');